import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import { CURATOR_LEGAL_APPROVAL_OPTIONS } from "../../../constant/constant";
import CustomCuratorRadioGroup from "./CustomCuratorRadioGroup";
import FileFormat from "../../../utils/Upload/FileFormat";
import ImageList from "../../Administration/Screens/LandingPageHero.js/ImageList";
import DropZone from "../../../utils/Upload/Dropzone";
import useThemeRender from "../../../theme/useThemeRender";
import { getImagePreview } from "../../../utils/function";
import { useSelector } from "react-redux";
import { downloadFileToLocal } from "../../../API/curatorApi";
import Loading from "../../../utils/Loader";

const Approval = ({
  isDisabled,
  approvalSection,
  setApprovalSection,
  uploadArtificatsFiles,
  deleteArtifcateFile,
}) => {
  const [isImageDropped, setIsImageDropped] = useState(false);
  const isDarkTheme = useSelector((state) => state.theme);
  const [loading, setLoading] = useState(false);
  const onDrop = (acceptedFiles) => {
    const newImage = acceptedFiles[0];

    uploadArtificatsFiles(acceptedFiles, true);
    setIsImageDropped(true);
    setApprovalSection((stateData) => {
      return {
        ...stateData,
        dropImage: getImagePreview(newImage),
      };
    });
  };

  const onReplace = async (acceptedFiles) => {
    const newImage = acceptedFiles[0]?.file;

    uploadArtificatsFiles([newImage], true);
    setIsImageDropped(true);
    setApprovalSection((stateData) => {
      return {
        ...stateData,
        dropImage: getImagePreview(newImage),
      };
    });
  };

  const handleDeleteClick = async (file) => {
    deleteArtifcateFile(
      approvalSection?.uploadedImageId || approvalSection?.islegalFiledId
    );
    setIsImageDropped(false);
    setApprovalSection({
      legalApproval: null,
      dropImage: null,
      uploadedImageId: null,
      fileName: "",
      islegalFiledId: null,
    });
  };

  const getSelectedLegalOptions = (selectedValue) => {
    if (selectedValue === false || selectedValue === 3) {
      return 3;
    }
    if (selectedValue === true || selectedValue === 2) {
      return 2;
    }
    if (selectedValue === false || selectedValue === 1) {
      return 1;
    }

    return null;
  };

  const { getRootProps, getInputProps } = useDropzone({
    disabled: isDisabled,
    accept: {
      "image/jpeg": [".jpeg", ".png"],
      "application/pdf": [".pdf"],
    },
    onDrop,
    maxFiles: 1,
  });
  const handleOpen = async () => {
    setLoading(true);
    const response = await downloadFileToLocal(
      approvalSection?.islegalFiledId,
      true
    );
    if (response?.status === 200) {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        padding: "16px",
        background: useThemeRender("cardBackgroundColorLayer2"),
      }}
    >
      {loading && <Loading />}
      <CustomCuratorRadioGroup
        label={"Have you received legal approval?"}
        value={getSelectedLegalOptions(approvalSection?.legalApproval)}
        onChange={(e) => {
          setApprovalSection((stateData) => {
            return {
              ...stateData,
              legalApproval: parseInt(e?.target?.value),
            };
          });
        }}
        radioGroup={CURATOR_LEGAL_APPROVAL_OPTIONS}
      />

      <Box sx={{ width: { xs: "100%", md: "400px" } }}>
        {isImageDropped ? (
          <ImageList
            images={[approvalSection?.dropImage]}
            onDelete={handleDeleteClick}
            onReplace={onReplace}
            label="Replace File"
          />
        ) : (
          <DropZone
            onDrop={onDrop}
            getRootProps={getRootProps}
            getInputProps={getInputProps}
            isDarkTheme={isDarkTheme}
            label="Document"
            isDisabled={isDisabled}
            uploadImageLabel="Upload File"
          />
        )}
      </Box>

      <Box
        onClick={handleOpen}
        sx={{
          padding: "8px",
          display: "flex",
          gap: "8px",
          alignItems: "center",
          cursor: "pointer",
          "& svg": {
            height: "16px",
            width: "16px",
          },

          "& svg > g > path": {
            fill: "#0078A7",
          },
        }}
      >
        {approvalSection?.fileName !== "" &&
          approvalSection?.fileName !== undefined && <FileFormat />}
        <Typography
          sx={{
            fontFamily: "var(--Typography-Font-Family-Body, Inter)",
            fontSize: "12px",
            fontWeight: 400,
            color: useThemeRender("textColorLayer2"),
          }}
        >
          {approvalSection?.fileName !== "" &&
            approvalSection?.fileName !== undefined &&
            approvalSection?.fileName}
        </Typography>
      </Box>
    </Box>
  );
};

export default Approval;
